var _this = module.exports = {
  globalLoader: function(status)
  {
    if ( status == true )
    {
      $('#global-loader').addClass('is-active')
    }
    else
    {
      $('#global-loader').removeClass('is-active')
    }
  },
  requestPaymentCheckout: function(pm, type)
  {
    var request = $.ajax({
      url: '/payment/checkout',
      data: {
        pm: pm,
        type: type
      },
      method: 'post',
      cache: false,
      dataType: 'json',
      success: function (data)
      {
        if ( data.type == 'paypal' )
        {
          $('#payment-control-checkout').html(data.html);
          $('#payment-control-checkout form').submit();
        }
        else if ( data.type == 'creditcard' )
        {
          $('#payment-content-checkout').html(data.html);
          $('#payment-content-checkout form').submit();
        }
      },
      error: function (XMLHttpRequest, textStatus, errorThrown)
      {
        if ( errorThrown != 'abort' )
        {
          console.log(XMLHttpRequest);
          console.log(textStatus);
          console.log(errorThrown);
        }
        _this.globalLoader(false)
      }
    })
  },
  getURLParameter: function(sParam)
  {
    var output        = ''
    var sPageURL      = window.location.search.substring(1)
    var sURLVariables = sPageURL.split('&')
    for (var i = 0; i < sURLVariables.length; i++)
    {
      var sParameterName = sURLVariables[i].split('=')
      if (sParameterName[0] == sParam)
      {
        output = sParameterName[1]
      }
    }
    return output
  },
  validateForm: function(type, form, fields)
  {
    var error = false
    var validate

    fields.forEach(function(element) {
      validate = false

      // Clean styles
      $(form + ' #group-' + element).removeClass('has-success').removeClass('has-error').removeClass('has-feedback')
      $(form + ' #group-' + element + ' span.glyphicon').remove()
      $(form + ' #group-' + element + ' span.sr-only').remove()
      //

      if ( $(form + ' label[for="' + element + '"]').hasClass('required') )
      {
        validate = true
      }

      if ( element == 'form-address-company' || element == 'form-address-tva' )
      {
        if ( type == 'individual' )
        {
          validate = false
        }

        if ( element == 'form-address-tva' )
        {
          if ( $(form + ' select[name="form-address-country"]').val() != 'FR' )
          {
            validate = false
          }
        }
      }

      if ( validate )
      {
        if( element == 'form-address-country' )
        {
          if ( $(form + ' select[name="' + element + '"]').val() == '' )
          {
            error = true
            $(form + ' #group-' + element).addClass('has-error').addClass('has-feedback')
            $(form + ' #group-' + element).append('<span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"></span><span class="sr-only">(error)</span>')
          }
          else
          {
            $(form + ' #group-' + element).addClass('has-success').addClass('has-feedback')
            $(form + ' #group-' + element).append('<span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true"></span><span class="sr-only">(success)</span>')
          }
        }
        else
        {
          switch( $(form + ' input[name="' + element + '"]').attr('type') )
          {
            case 'text':
              if ( $(form + ' input[name="' + element + '"]').val() == '' )
              {
                error = true
                $(form + ' #group-' + element).addClass('has-error').addClass('has-feedback')
                $(form + ' #group-' + element).append('<span class="glyphicon glyphicon-remove form-control-feedback" aria-hidden="true"></span><span class="sr-only">(error)</span>')
              }
              else
              {
                $(form + ' #group-' + element).addClass('has-success').addClass('has-feedback')
                $(form + ' #group-' + element).append('<span class="glyphicon glyphicon-ok form-control-feedback" aria-hidden="true"></span><span class="sr-only">(success)</span>')
              }
            break;
            case 'radio':
              if ( $(form + ' input[name="' + element + '"]:checked').val() == undefined )
              {
                error = true
                $(form + ' #group-' + element).addClass('has-error')
              }
              else
              {
                $(form + ' #group-' + element).addClass('has-success')
              }
            break;
          }
        }
      }
    })

    return error
  },
  dataLayerPush: function(obj)
  {
    dataLayer.push(obj)
  }
  
}



// WEBPACK FOOTER //
// ./js/common.js